// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2VJ7K","loaderOuter":"PageOverlayLoader_loaderOuter__3M5Ws"};